import React, { useContext } from 'react';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';
import DefaultMaxPlan from '../Plans/DefaultMaxPlan';
import { PlanPrices, SavingsRewards } from '../../../../utils/prices';

interface Props {
  app: AppType;
  plans: PlanPrices;
  savings: SavingsRewards;
  onInfoClicked: (plan: Plan) => void;
  onUpgradeClicked: (plan: Plan) => void;
  onExploreAllPlansClicked: () => void;
  onSkip: () => void;
  onBackClicked: () => void;
}

const DefaultMaxPlanContainer = ({
  app,
  plans,
  savings,
  onInfoClicked,
  onExploreAllPlansClicked,
  onUpgradeClicked
}: Props) => {
  const { loading } = app;
  const { analytics } = useContext(AnalyticsContext);

  return (
    <>
      <h1 data-e2e="upgrade-plans-header">{'Let’s get started'}</h1>
      <img
        className={css.investDefault}
        src="/static/default-max-plan-sm.svg"
        alt="default max plan"
      />
      <h2
        data-testid="upgrade-plans-subheader"
        data-e2e="upgrade-plans-subheader"
      >
        {}
      </h2>
      <DefaultMaxPlan
        onInfoClicked={onInfoClicked}
        savings={savings}
        plans={plans}
        onLearnMoreClicked={(_, plan) => {
          onInfoClicked(plan);
        }}
        loading={loading}
        analytics={analytics}
        onUpgradeClicked={onUpgradeClicked}
        flowId={app.flowId ?? ''}
        onExploreAllPlansClicked={onExploreAllPlansClicked}
      />
      <div className={css.investFooter}>
        <p>
          **See Greenlight&apos;s Terms of Service for details on earnings
          limits and how to qualify. Subject to change at any time.
        </p>
        <p>
          ***Cell phone and purchase protection provided by Virginia Surety
          Company Inc. Cell phone protection is not available to residents of
          New York.
        </p>
        <p>
          Depending on where you live, you may be charged taxes in addition to
          your subscription price.
        </p>
        <p>
          By continuing, you are accepting Greenlight’s
          <a
            target="_blank"
            href={`https://greenlight.com/terms-of-service`}
            data-e2e="terms"
            rel="noreferrer"
          >
            Terms of Service
          </a>{' '}
          &{' '}
          <a
            target="_blank"
            href={`https://greenlight.com/privacy`}
            data-e2e="privacy-policy"
            rel="noreferrer"
          >
            Privacy Statement
          </a>
          .
        </p>
      </div>
    </>
  );
};

export default DefaultMaxPlanContainer;
